import type * as SchemaTypes from '../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitMl360AssessmentResultMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.SubmitMl360AssessmentResultInput;
}>;


export type SubmitMl360AssessmentResultMutation = (
  { __typename: 'Mutation' }
  & { submitML360AssessmentResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'SubmitML360AssessmentResultSuccessfulResponse' }
    & { result?: SchemaTypes.Maybe<(
      { __typename: 'AssessmentResult' }
      & Ml360AssessmentResultFragment
    )> }
  ) }
);

export type Ml360AssessmentResultFragment = (
  { __typename: 'AssessmentResult' }
  & Pick<SchemaTypes.AssessmentResult, 'id' | 'companyId' | 'userId' | 'moduleInstanceId' | 'courseInstanceId' | 'assessmentRunId' | 'createdAt'>
  & { company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'id' | 'name'>
  ), user?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name' | 'email' | 'isSuperAdmin'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'role' | 'email'>
  )>, moduleInstance?: SchemaTypes.Maybe<(
    { __typename: 'ModuleInstance' }
    & Pick<SchemaTypes.ModuleInstance, 'name'>
  )>, courseInstance?: SchemaTypes.Maybe<(
    { __typename: 'CourseInstance' }
    & Pick<SchemaTypes.CourseInstance, 'name'>
  )>, assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & Pick<SchemaTypes.AssessmentRun, 'name'>
  )>, result: { __typename: 'CardioRespResult' } | { __typename: 'IndividualMotivationResult' } | (
    { __typename: 'ML360Result' }
    & Ml360AssessmentResultDataFragment
  ) | { __typename: 'SartResult' } | { __typename: 'SelfDeterminationResult' } | { __typename: 'SpatialPlanningResult' } | { __typename: 'StrengthResult' } | { __typename: 'TeamResilienceResult' } | { __typename: 'TrainersNotesResult' } | { __typename: 'VisualReactionResult' } }
);

export type Ml360AssessmentResultDataFragment = (
  { __typename: 'ML360Result' }
  & { surveys: Array<(
    { __typename: 'ML360SurveyResult' }
    & Pick<SchemaTypes.Ml360SurveyResult, 'category' | 'question'>
    & { scoring: (
      { __typename: 'Scoring' }
      & Pick<SchemaTypes.Scoring, 'label' | 'score'>
    ) }
  )>, categoryAverages: Array<(
    { __typename: 'ML360CategoryResult' }
    & Pick<SchemaTypes.Ml360CategoryResult, 'category' | 'averageScore' | 'maxScore'>
  )> }
);

export const Ml360AssessmentResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment ML360AssessmentResultData on ML360Result {
  surveys {
    ... on ML360SurveyResult {
      category
      question
      scoring {
        ... on Scoring {
          label
          score
        }
      }
    }
  }
  categoryAverages {
    category
    averageScore
    maxScore
  }
}
    `;
export const Ml360AssessmentResultFragmentDoc = /*#__PURE__*/ gql`
    fragment ML360AssessmentResult on AssessmentResult {
  id
  companyId
  company {
    id
    name
  }
  userId
  user {
    __typename
    ... on TenantUser {
      id
      name
      role
      email
    }
    ... on SuperAdminUser {
      id
      name
      email
      isSuperAdmin
    }
  }
  moduleInstanceId
  moduleInstance {
    name
  }
  courseInstanceId
  courseInstance {
    name
  }
  assessmentRunId
  assessmentRun {
    name
  }
  result {
    ...ML360AssessmentResultData
  }
  createdAt
}
    `;
export const SubmitMl360AssessmentResultDocument = /*#__PURE__*/ gql`
    mutation SubmitML360AssessmentResult($input: SubmitML360AssessmentResultInput!) {
  submitML360AssessmentResult(input: $input) {
    ... on SubmitML360AssessmentResultSuccessfulResponse {
      result {
        ...ML360AssessmentResult
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${Ml360AssessmentResultFragmentDoc}
${Ml360AssessmentResultDataFragmentDoc}`;
export type SubmitMl360AssessmentResultMutationFn = Apollo.MutationFunction<SubmitMl360AssessmentResultMutation, SubmitMl360AssessmentResultMutationVariables>;

/**
 * __useSubmitMl360AssessmentResultMutation__
 *
 * To run a mutation, you first call `useSubmitMl360AssessmentResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitMl360AssessmentResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitMl360AssessmentResultMutation, { data, loading, error }] = useSubmitMl360AssessmentResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitMl360AssessmentResultMutation(baseOptions?: Apollo.MutationHookOptions<SubmitMl360AssessmentResultMutation, SubmitMl360AssessmentResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitMl360AssessmentResultMutation, SubmitMl360AssessmentResultMutationVariables>(SubmitMl360AssessmentResultDocument, options);
      }
export type SubmitMl360AssessmentResultMutationHookResult = ReturnType<typeof useSubmitMl360AssessmentResultMutation>;
export type SubmitMl360AssessmentResultMutationResult = Apollo.MutationResult<SubmitMl360AssessmentResultMutation>;
export type SubmitMl360AssessmentResultMutationOptions = Apollo.BaseMutationOptions<SubmitMl360AssessmentResultMutation, SubmitMl360AssessmentResultMutationVariables>;